import '.an{max-width:1280px;}.ssr-plugin'
import '.ap{margin:0 auto;}.ssr-plugin'
import '.e{display:flex;}.ssr-plugin'
import '.w{align-items:center;}.ssr-plugin'
import '.m{width:100%;}.ssr-plugin'
import '.ao{justify-content:space-between;}.ssr-plugin'
import '.bj{gap:144px;}.ssr-plugin'
import '.bk{max-width:568px;}.ssr-plugin'
import '.bl{margin-bottom:16px;}.ssr-plugin'
import '.bm{margin-bottom:48px;}.ssr-plugin'
import '.bn{margin-bottom:24px;}.ssr-plugin'
import '.bo{text-align:left;}.ssr-plugin'
import { styled } from 'inlines'
import { Layout } from '../../components/Layout.js'
import { colors } from '../../utils/colors.js'
import { useTrack } from '../../hooks/useTrack.js'
import { AnalyticsEvent } from '../../../../shared/analyticsEvents.js'
import { TABLET } from '../../utils/breakpoints.js'
import { useLanguage } from '../../hooks/useLanguage.js'
import { useDictionary } from '../../hooks/useDictionary.js'
import { LinkNotes } from './LinkNotes.js'
import { useEffect } from 'react'
import { useScrollToTop } from '../../hooks/useScrollToTop.js'

export const Imprint = () => {
  const track = useTrack('imprint')

  const [lang] = useLanguage()
  const { legalGroupTitle, imprint, moreInfoReachOut } = useDictionary()

  useScrollToTop()

  useEffect(() => {
    track(AnalyticsEvent.PAGE_LOAD)
  }, [])

  return (
    <Layout>
      <styled.div className="an ap e w m ao bj"
        style={{
          [TABLET]: {
            flexDirection: 'column',
            gap: '72px',
          },
        }}
      >
        {/* column 1 */}
        <styled.div className="bk"
          style={{
            textAlign: lang.rtl ? 'right' : 'left',
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
        >
          <h3 className="bl">{legalGroupTitle}</h3>
          <h2 className="bm" style={{ color: colors.primary,}}>
            {imprint}
          </h2>
          <p className="bn">{moreInfoReachOut}</p>
          <LinkNotes />
        </styled.div>
        {/* column 2 */}
        <styled.div className="bo bk"
          dir="ltr"
          style={{
            '& p': {
              // @ts-ignore
              textAlign: 'left !important',
              margin: '1em 0em',
            },
            [TABLET]: {
              maxWidth: 'none',
            },
          }}
        >
          <p>
            Once Germany GmbH
            <br />
            Schanzenstraße 38
            <br />
            51063 Cologne
            <br />
            Germany
          </p>

          <p>
            T: +49 (221) 59 68-88 00
            <br />
            E: info@esc.vote
            <br />
            W: www.once.net
          </p>

          <p>
            Handelsregister Köln | HRB 55372
            <br />
            Tax ID: 218/5728/3147 | VAT ID: DE243135863
            <br />
            Directors: Thomas Niedermeyer & Sebastian Winzen
          </p>
        </styled.div>
      </styled.div>
    </Layout>
  )
}
